module.exports = __webpack_public_path__ + "static/media/avatar_snake.1966d2a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_snake.png
// module id = 398
// module chunks = 0